export const removeMetadataAndCreateFile = (file: File, type: string): Promise<File> => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);

        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;

            const ctx = canvas.getContext('2d');
            ctx?.drawImage(img, 0, 0);

            canvas.toBlob(blob => {
                const newFile = new File([blob as Blob], file.name, {
                    type,
                    lastModified: Date.now(),
                });

                resolve(newFile);
            }, type);
        };

        img.onerror = error => {
            reject(error);
        };
    });
};
